﻿import React, {FC} from 'react';
import {SlotType} from "../../types/Slots";
import {useSlotOrDefault} from "../../hooks/slots/useSlotOrDefault";
import {
  CardSubRowContainer,
  CardItemValue
} from "@securspace/securspace-ui-kit";
import { CardItemLabel } from "./CardItemLabel";

type CardSubBodyItemProps = React.ComponentPropsWithoutRef<'div'> & {
  value: SlotType;
  label: SlotType;
}

const cardItemValueProps = { sx: { wordBreak: 'break-all' } };

const CardSubBodyItem: FC<CardSubBodyItemProps> = ({ value, label, ...rest}) => {
  const Label = useSlotOrDefault(label, CardItemLabel);
  const Value = useSlotOrDefault(value ?? '-', CardItemValue, cardItemValueProps);

  return <CardSubRowContainer {...rest} style={{ minWidth: 0, ...rest.style }}>
    {Label}
    {Value}
  </CardSubRowContainer>
}

export { CardSubBodyItem };
